import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const pathA = ['Seguir posponiendo tu idea de negocio', 'Ver pasar los meses sin ingresos extra', 'Sentir que "no eres buena para esto"', 'Quedarte donde estás, sin cambios'];
const pathB = ['Tener tu producto listo en 7 días', 'Generar tus primeros ingresos digitales', 'Demostrar que SÍ puedes emprender', 'Construir un activo que genera dinero mientras duermes'];
export function TwoPaths() {
  const handleCTAClick = () => {
    trackAddToCart();
    window.open('https://www.vitarutinas.com/cart/50347583471862:1', '_blank');
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-3xl md:text-4xl text-dark text-center mb-12" data-id="element-180">
          Tienes dos caminos hoy
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-181">
          {/* Path A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-lg opacity-60 grayscale" data-id="element-182">
            <h3 className="font-bold text-2xl text-dark mb-6 text-center" data-id="element-183">
              Camino A: No hacer nada
            </h3>
            <div className="space-y-4" data-id="element-184">
              {pathA.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-185">
                  <XCircle className="w-6 h-6 text-gray-400 flex-shrink-0 mt-1" data-id="element-186" />
                  <p className="text-body" data-id="element-187">{item}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Path B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-lg border-2 border-primary shadow-lg relative" data-id="element-188">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-189">
              <span className="bg-primary text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-190">
                EL CAMINO RECOMENDADO
              </span>
            </div>
            <h3 className="font-bold text-2xl text-dark mb-6 text-center mt-4" data-id="element-191">
              Camino B: Tomar acción hoy
            </h3>
            <div className="space-y-4" data-id="element-192">
              {pathB.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-193">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-194" />
                  <p className="text-dark font-medium" data-id="element-195">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-196">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} onClick={handleCTAClick} className="shimmer-cta pulse-glow w-full md:w-auto px-8 py-4 rounded-lg text-white font-bold text-lg" data-id="element-197">
            QUIERO EL CAMINO B — EMPEZAR POR $110 MXN →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}